export default "__VITE_ASSET__DrS5iQrV__"